import { requester } from '@/api/axios';

import { apiConst, keyConst } from '@/constants';

import { AllRole, ApiResponse, createRoleFrom } from '@/interface';

// create role
export const createRole = async (data: createRoleFrom): Promise<ApiResponse<AllRole>> => {
  const config = {
    method: 'post',
    url: apiConst.roles,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}`,
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(data),
  };

  return await requester(config);
};
export const getRoleById = async (id: string) => {
  const config = {
    method: 'get',
    url: `${apiConst.roles}/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}`,
      'Content-Type': 'application/json',
    },
  };

  return await requester(config);
};

export const updateRole = async (id: string, data: createRoleFrom): Promise<ApiResponse<AllRole>> => {
  const config = {
    method: 'patch',
    url: `${apiConst.roles}/${id}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}`,
    },
    data: JSON.stringify(data),
  };

  return await requester(config);
};
// get all roles
export const allRoles = async (): Promise<ApiResponse<AllRole[]>> => {
  const companyId = localStorage.getItem(keyConst.companyId);
  const token = localStorage.getItem(keyConst.userToken);
  const config = {
    method: 'get',
    url: `${apiConst.roles}?companyId=${companyId}`,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  return await requester(config);
};
// get all permissions
export const getAllowedPermissions = async (): Promise<ApiResponse<{ permissions: Record<string, 0 | 1> }>> => {
  const token = localStorage.getItem(keyConst.userToken);
  const config = {
    method: 'get',
    url: apiConst.getAllowedPermissions,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
  };

  return await requester(config);
};

export const deleteRole = async (id: string): Promise<ApiResponse<unknown>> => {
  const config = {
    method: 'delete',
    url: `${apiConst.roles}/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}`,
      'Content-Type': 'application/json',
    },
  };
  return await requester(config);
};
